import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import InfoIcon from 'grommet/components/icons/base/Info';
import Reflux from 'reflux';
import CloseIcon from 'grommet/components/icons/base/Close';

export default class SliderLinks extends Reflux.Component {
  constructor(props){
    super(props);
    this.state ={}
    this.store = new SliderLinksStore(props);
  }
  doClose(e){
    e.preventDefault();
    this.props.SlideActions.toggleLinks(false);
  }
  render() {
    if(this.props.content.length==0){
      return false;
    }

    const sliderClass = cx({
      'active': this.state.isActive,
      'slider-links': true
    })
    const wrapperClass = cx({
        'links-content-wrapper': true
    });
    const links = Utils.getDangerousHtml(this.props.content);
    return (
        <div className={sliderClass}>
          <div className={wrapperClass} >
            <this.props.Buttons.Close onClick={ this.doClose.bind(this)} />
            <div className="slide-links" dangerouslySetInnerHTML={links}></div>
          </div>
        </div>
    );
  }
}
SliderLinks.propTypes={
    content: React.PropTypes.string,
    SlideActions: React.PropTypes.object,
    Buttons: React.PropTypes.object
}
SliderLinks.defaultProps={
  content: ''
}

class SliderLinksStore extends Reflux.Store
{
    constructor(props)
    {
        super();
        this.props = props;
        this.state = this.getInitialState();
        this.listenables = props.SlideActions;
    }
    getInitialState(){
        return {
          isActive: false
        }
    }
    beforeChange(currIndex,nextIndex){
        this.setState({
          isActive: false
        })
    }
    onToggleLinks(flag = !this.state.isActive){
      this.setState({
        isActive: flag
      })
    }
    onToggleNotes(){
        this.setState({
          isActive: false
        })
    }
}






// WEBPACK FOOTER //
// ./src/app/carousel/slider-links.jsx